<template>
  <v-container>
    <section>
      <v-layout column align-center justify-center class="blue--text">
          <input type="file" @change="onFileSelected">
        
        <v-btn @click="onUpload">Upload</v-btn>
      </v-layout>
    </section>
  </v-container>
</template>

<script>
import {firebaseStorage, firebasedb} from '.././firebase';
    export default {
        name:'IQFirmware',
        data() {
            return {
                selectedFile: null
            };
        },
        methods:{
            onFileSelected(event){
                console.log(event);
                this.selectedFile = event.target.files[0];
                console.log(this.selectedFile)
            },
            onUpload() {
                //put in firebase storage.
                let storageRef = firebaseStorage.ref('iqce');
                let fileRef = storageRef.child(this.selectedFile.name);
                let uploadTask = fileRef.put(this.selectedFile);
                uploadTask.then((snapshot) => {
                    console.log(snapshot.downloadURL);
                    let testCurrentIQce = {};
                    testCurrentIQce.fileName = this.selectedFile.name;
                    testCurrentIQce.folder = 'iqce';
                    testCurrentIQce.url = snapshot.downloadURL;
                    console.log(testCurrentIQce);
                    firebasedb.ref('testCurrentIQce').set(testCurrentIQce);
                    let temp = true;
                    firebasedb.ref('settings/setting').set(temp);
                    //update firebase

                })
            }
        }
    
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/IQFirmware.vue